import globals from '@/globals';
import { isProduction } from '@/utils/tools';
import { INIT_MODE_DEV, INIT_MODE_PROD } from '@/utils/init_app_helper';

function init() {
  if (isProduction()) {
    INIT_MODE_PROD();
  } else {
    INIT_MODE_DEV();
  }
}

globals.context.addEventListener('load', init, { once: true });
